import { Outlet } from "react-router-dom"
import { Header } from "./header"
import { Footer } from "./footer"
import { ConsentModal } from "@/components/ConsentModal"
import { NetworkGuard } from "@/components/NetworkGuard"

export function Layout() {
  return (
    <div className="relative flex min-h-screen flex-col">
      <Header />
      <NetworkGuard />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ConsentModal />
    </div>
  )
}

export { Header } from "./header"
export { Footer } from "./footer"
